// Destinazione di stampa (questo dispositivo o una Stazione di stampa remota)
import React, { useEffect, useState } from "react";
import { wmsApi, openWmsPdf } from "./wmsApi";

export const getPrintTarget = () => {
  try { return JSON.parse(localStorage.getItem("itrace_print_target") || "null"); } catch { return null; }
};
export const setPrintTarget = (t) => localStorage.setItem("itrace_print_target", JSON.stringify(t));

// Stampa una lista di pezzi rispettando la destinazione scelta
export async function printPieces(pieceIds, preTab = null) {
  const t = getPrintTarget();
  if (t?.type === "station" && t.id) {
    if (preTab) preTab.close();
    await wmsApi.post("/wms/print-jobs", { station_id: t.id, piece_ids: pieceIds });
    return { mode: "station", name: t.name };
  }
  for (const id of pieceIds) {
    await openWmsPdf(`/wms/labels/piece/${id}.pdf`, pieceIds.length === 1 ? preTab : null);
  }
  return { mode: "device" };
}

export function PrintTargetSelector({ className = "" }) {
  const [stations, setStations] = useState([]);
  const [target, setTarget] = useState(getPrintTarget());

  useEffect(() => { wmsApi.get("/wms/print-stations").then((r) => setStations(r.data)).catch(() => {}); }, []);

  const value = target?.type === "station" ? `station:${target.id}` : "device";
  const change = (v) => {
    if (v === "device") { setPrintTarget({ type: "device" }); setTarget({ type: "device" }); return; }
    const st = stations.find((s) => s.id === v.slice(8));
    const t = { type: "station", id: st.id, name: st.name };
    setPrintTarget(t); setTarget(t);
  };

  return (
    <div className={className}>
      <p className="text-xs tracking-[0.15em] uppercase font-bold text-zinc-500 mb-1.5">Stampa etichette su</p>
      <select
        value={value}
        onChange={(e) => change(e.target.value)}
        className="h-14 w-full px-3 bg-white border-2 border-zinc-300 font-bold text-sm uppercase focus:border-[#FF4500] focus:outline-none"
        data-testid="print-target-select"
      >
        <option value="device">Questo dispositivo (PDF)</option>
        {stations.map((s) => <option key={s.id} value={`station:${s.id}`}>Postazione: {s.name}</option>)}
      </select>
    </div>
  );
}
